<template>
  <a :href="href" class="event-card d-flex flex-column flex-m-row justify-content-between">
    <div class="information-wrapper d-flex flex-column">
      <div class="dates">
        <span class="start"
          >{{ formatDate(eventStartDate, formatStartDate) }} -</span
        >
        <span class="end">
          {{ formatDate(eventEndDate, formatEndDate) }}</span
        >
      </div>
      <div class="information">
        <div class="text">
          <div class="title" v-text="eventName"></div>
          <EventLocation :city="eventCity" :postal-code="eventPostalCode"></EventLocation>
        </div>
      </div>
    </div>
    <EventCrops :eventCrops="eventCrops"></EventCrops>
  </a>
</template>

<script>
import EventMixin from '../mixins/EventMixin';
import EventCrops from './event-crops.vue';
import EventLocation from './event-location.vue';

export default {
  name: 'EventCard',
  components: {
    EventCrops,
    EventLocation,
  },
  props: {
    eventName: String,
    eventStartDate: String,
    eventEndDate: String,
    eventPostalCode: String,
    eventCity: String,
    eventCrops: String,
    href: String,
  },
  mixins: [EventMixin],
  inject: ['formatStartDate', 'formatEndDate'],
};
</script>

<style lang="scss">
.event-card {
  color: #333333;
  font-size: 16px;
  margin-bottom: 20px;
  &:hover {
    text-decoration: none;
  }
  .information-wrapper {
    .dates {
      width: 100%;
    }
  }
}
</style>
